module.exports = __webpack_public_path__ + "img/area1_thumbnail_061221.07f15908.jpg";